{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              155.71873370559177,
              -4.803097574312886
            ],
            [
              150.92182335165978,
              0.15161825679955143
            ],
            [
              141.03657795541875,
              -1.666965397517302
            ],
            [
              141.00755136034172,
              -9.495748020047756
            ],
            [
              154.40684368480186,
              -12.216057471149284
            ],
            [
              155.9089071173404,
              -8.170273191899454
            ],
            [
              156.34597867219713,
              -6.337548674306518
            ],
            [
              155.71873370559177,
              -4.803097574312886
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}